import { MessageCircle } from 'lucide-react';

export default function WhatsAppButton() {
  const whatsappGroupUrl = 'https://chat.whatsapp.com/L818Fq4NLh8CidBkbGhhGa?mode=gi_t';

  return (
    <a
      href={whatsappGroupUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 bg-[#25D366] text-white p-4 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-110"
      data-testid="whatsapp-float-button"
      aria-label="Join WhatsApp Group"
    >
      <MessageCircle size={28} />
    </a>
  );
}